/**
 * A collection of utility functions for the application.
 */

/**
 * Returns the appropriate unit label for a given data type.
 * @param {string} dataType - The type of data (e.g., 'temperature', 'humidity').
 * @param {boolean} isMetric - Whether to return metric or imperial units.
 * @returns {string} The unit label (e.g., '°C', '%').
 */
export const getUnitLabel = (dataType, isMetric) => {
    const lowerCaseType = dataType?.toLowerCase() || '';
    if (lowerCaseType.includes('temperature')) {
        return isMetric ? '°C' : '°F';
    }
    if (lowerCaseType.includes('humidity')) {
        return '%';
    }
    if (lowerCaseType.includes('pressure')) {
        return 'hPa';
    }
    return '';
};

/**
 * Formats a timestamp string into a more readable locale-specific string.
 * @param {string} timestamp - The ISO 8601 timestamp string.
 * @returns {string} A formatted date and time string.
 */
export const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    try {
        const date = new Date(timestamp);
        return date.toLocaleString();
    } catch (error) {
        return 'Invalid Date';
    }
};

/**
 * Returns a Bootstrap gradient class based on a sensor's status.
 * @param {string} status - The status of the sensor ('online', 'offline', etc.).
 * @returns {string} A Bootstrap background class.
 */
export const getStatusClass = (status) => {
    switch (status) {
        case 'online':
            return 'bg-gradient-success';
        case 'offline':
            return 'bg-gradient-danger';
        case 'pending':
            return 'bg-gradient-warning';
        default:
            return 'bg-gradient-info';
    }
};
